/* Peintio cart drawer — 20 sep 2026 (upsell source changed 22 sep, "tydlig varukorg" 17 okt).
   17 okt: the one-at-a-time upsell card became a swipe row ("Gör den till 3 för 2") of best sellers, each with a
   "+" that opens a size + kant picker preselected to the SAME size/edge as the first poster in the cart (data-variant
   on .pc-rail), so the customer reaches 3 för 2 without leaving the cart and can still pick another size (round 2, 17 okt). Heading comes from snippets/cart-drawer.liquid.
   Everything else (open/close, quantity, remove, re-render after add) is the theme's own JS (app.js CartDrawer);
   this file only reacts to the drawer being (re)rendered. Loaded with defer after app.js from layout/theme.liquid.
   Upsell products (17 okt: SEASONAL best sellers = the Bästsäljare collection's own manual order, which follows the season, TODO 96): 1) /collections/best-selling-products-1?section_id=peintio-topsellers-json
   (sections/peintio-topsellers-json.liquid, compact JSON), 2) fallback Shopify recommendations for the first cart line,
   3) fallback /collections/all/products.json. Cart lines and gift cards are skipped. */
(function () {
  'use strict';
  if (window.peintioCartRail) { return; }
  window.peintioCartRail = true;

  var DRAWER_ID = 'Cart-Drawer';
  var MAX_CARDS = 8;
  var cache = { key: '', products: null };

  /* ---------- helpers ---------- */
  function money(cents) {
    var kr = Math.round(cents / 100);
    return String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  }
  function toCents(v) {
    if (typeof v === 'number') { return v; }
    var f = parseFloat(String(v || '0').replace(',', '.'));
    return isFinite(f) ? Math.round(f * 100) : 0;
  }
  function imageUrl(src, size) {
    if (!src) { return ''; }
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/') === -1) { return src; }
    src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    var joiner = src.indexOf('?') > -1 ? '&' : '?';
    return src + joiner + 'width=' + size;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (html != null) { n.innerHTML = html; }
    return n;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function normalize(p) {
    var variants = (p.variants || []).filter(function (v) { return v && v.available !== false; }).map(function (v) {
      return {
        id: v.id,
        title: v.title || '',
        price: toCents(v.price),
        compare: v.compare_at_price ? toCents(v.compare_at_price) : 0,
        image: (v.featured_image && v.featured_image.src) || (typeof v.image === 'string' ? v.image : null)
      };
    });
    var image = (typeof p.image === 'string' && p.image) || (p.featured_image && (p.featured_image.src || p.featured_image)) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: '/products/' + p.handle,
      image: typeof image === 'string' ? image : '',
      type: p.type || p.product_type || '',
      variants: variants
    };
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  var topSellersPromise = null;
  function fetchTopSellers() {
    if (topSellersPromise) { return topSellersPromise; }
    topSellersPromise = fetchTopSellersNow().then(function (list) {
      if (!list.length) { topSellersPromise = null; }
      return list;
    });
    return topSellersPromise;
  }
  function fetchTopSellersNow() {
    var url = ((window.theme && theme.routes && theme.routes.root_url) || '/').replace(/\/$/, '') + '/collections/best-selling-products-1?section_id=peintio-topsellers-json';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html && html.match(/<script type="application\/json" id="peintio-topsellers-json">([\s\S]*?)<\/script>/);
        if (!m) { return []; }
        try { return JSON.parse(m[1]) || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  function loadProducts(productId, exclude) {
    var key = productId + '|' + exclude.join(',');
    if (cache.key === key && cache.products) { return Promise.resolve(cache.products); }
    return fetchTopSellers().then(function (top) {
      if (top.length >= 3) { return top; }
      var rec = productId ? fetchJson('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related') : Promise.resolve(null);
      return rec.then(function (d) {
        var list = top.concat((d && d.products) || []);
        if (list.length >= 3) { return list; }
        return fetchJson('/collections/all/products.json?limit=16').then(function (c) {
          var more = (c && c.products) || [];
          var seen = {};
          list.forEach(function (p) { seen[p.handle] = true; });
          more.forEach(function (p) { if (!seen[p.handle]) { list.push(p); seen[p.handle] = true; } });
          return list;
        });
      });
    }).then(function (list) {
      var seenHandles = {};
      var out = list.map(normalize).filter(function (p) {
        if (!p.variants.length) { return false; }
        if (exclude.indexOf(p.handle) > -1) { return false; }
        if (seenHandles[p.handle]) { return false; }
        seenHandles[p.handle] = true;
        if (/gift|present/i.test(p.type) || /presentkort|gift card/i.test(p.title)) { return false; }
        return true;
      });
      cache = { key: key, products: out };
      return out;
    });
  }

  /* the variant matching the poster already in the cart: exact title ("21x30 cm / Med vit kant"), else same size, else first */
  function pickVariant(p, wanted) {
    var w = norm(wanted);
    if (w) {
      for (var i = 0; i < p.variants.length; i++) { if (norm(p.variants[i].title) === w) { return p.variants[i]; } }
      var size = w.split('/')[0].trim();
      if (size) {
        for (var j = 0; j < p.variants.length; j++) { if (norm(p.variants[j].title).indexOf(size) === 0) { return p.variants[j]; } }
      }
    }
    return p.variants[0];
  }

  /* ---------- the swipe row ---------- */
  function render(rail, products, heading, wanted) {
    if (!products.length) { rail.innerHTML = ''; return; }
    var box = el('div', 'pc-row');
    if (heading) { box.appendChild(el('div', 'pc-row-heading', esc(heading))); }
    var list = el('div', 'pc-row-list');
    products.slice(0, MAX_CARDS).forEach(function (p) {
      var v = pickVariant(p, wanted);
      var card = el('div', 'pc-card');
      var media = el('a', 'pc-card-media');
      media.href = p.url;
      var img = document.createElement('img');
      img.src = imageUrl(v.image || p.image, 240);
      img.width = 104; img.height = 104; img.alt = p.title; img.loading = 'lazy';
      media.appendChild(img);
      card.appendChild(media);
      var name = el('a', 'pc-card-name', esc(p.title));
      name.href = p.url;
      card.appendChild(name);
      var foot = el('div', 'pc-card-foot');
      foot.appendChild(el('span', 'pc-card-price', esc(money(v.price))));
      var add = el('button', 'pc-card-add', '<span aria-hidden="true">+</span>');
      add.type = 'button';
      add.setAttribute('aria-label', 'Lägg till ' + p.title + ' (' + v.title + ')');
      foot.appendChild(add);
      card.appendChild(foot);
      add.addEventListener('click', function () { openPicker(p, v, add); });
      list.appendChild(card);
    });
    box.appendChild(list);
    rail.innerHTML = '';
    rail.appendChild(box);
  }

  /* ---------- size + kant picker (17 okt, round 2): "+" opens it, preselected to the cart's first poster ---------- */
  function splitTitle(t) {
    var parts = String(t || '').split(' / ');
    return { size: (parts[0] || '').trim(), kant: (parts[1] || '').trim() };
  }
  function closePicker() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    var nodes = drawer.querySelectorAll('.pc-pick, .pc-pick-backdrop');
    for (var i = 0; i < nodes.length; i++) { nodes[i].parentNode.removeChild(nodes[i]); }
  }
  function openPicker(p, preselected, cardButton) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    closePicker();
    var host = drawer;
    try { if (getComputedStyle(drawer).position === 'static') { host = drawer.querySelector('.side-panel-inner') || drawer; } } catch (e) {}

    var opts = p.variants.map(function (v) { var o = splitTitle(v.title); o.v = v; return o; });
    var sizes = [], kants = [];
    opts.forEach(function (o) {
      if (sizes.indexOf(o.size) === -1) { sizes.push(o.size); }
      if (o.kant && kants.indexOf(o.kant) === -1) { kants.push(o.kant); }
    });
    var cur = splitTitle(preselected.title);
    function find(size, kant) {
      for (var i = 0; i < opts.length; i++) { if (opts[i].size === size && (!kants.length || opts[i].kant === kant)) { return opts[i].v; } }
      return null;
    }

    var backdrop = el('div', 'pc-pick-backdrop');
    var sheet = el('div', 'pc-pick');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Välj storlek för ' + p.title);
    var close = el('button', 'pc-pick-close', '&times;');
    close.type = 'button';
    close.setAttribute('aria-label', 'Stäng');
    sheet.appendChild(close);

    var head = el('div', 'pc-pick-head');
    var imgBox = el('div', 'pc-pick-img');
    var img = document.createElement('img');
    img.width = 72; img.height = 72; img.alt = p.title;
    imgBox.appendChild(img);
    head.appendChild(imgBox);
    head.appendChild(el('div', 'pc-pick-title', esc(p.title)));
    sheet.appendChild(head);

    sheet.appendChild(el('div', 'pc-pick-label', 'Storlek'));
    var sizeBox = el('div', 'pc-pick-opts pc-pick-size');
    sheet.appendChild(sizeBox);
    var kantBox = null;
    if (kants.length > 1) {
      sheet.appendChild(el('div', 'pc-pick-label', 'Kant'));
      kantBox = el('div', 'pc-pick-opts pc-pick-kant');
      sheet.appendChild(kantBox);
    }
    var addBtn = el('button', 'pc-pick-add');
    addBtn.type = 'button';
    sheet.appendChild(addBtn);
    sheet.appendChild(el('div', 'pc-pick-note', 'Räknas in i 3 för 2 och 5 för 3'));

    function paint() {
      var chosen = find(cur.size, cur.kant);
      sizeBox.innerHTML = '';
      sizes.forEach(function (sz) {
        var v = find(sz, cur.kant);
        var b = el('button', 'pc-opt' + (sz === cur.size ? ' is-on' : ''), esc(sz.replace(/\s*cm$/i, '')) + '<small>' + (v ? esc(money(v.price)) : '–') + '</small>');
        b.type = 'button';
        if (!v) { b.disabled = true; }
        b.addEventListener('click', function () { cur.size = sz; paint(); });
        sizeBox.appendChild(b);
      });
      if (kantBox) {
        kantBox.innerHTML = '';
        kants.forEach(function (k) {
          var v = find(cur.size, k);
          var b = el('button', 'pc-opt' + (k === cur.kant ? ' is-on' : ''), esc(k));
          b.type = 'button';
          if (!v) { b.disabled = true; }
          b.addEventListener('click', function () { cur.kant = k; paint(); });
          kantBox.appendChild(b);
        });
      }
      img.src = imageUrl((chosen && chosen.image) || p.image, 200);
      addBtn.disabled = !chosen;
      addBtn.textContent = chosen ? 'Lägg till – ' + money(chosen.price) : 'Ej tillgänglig';
    }
    if (!find(cur.size, cur.kant)) { var o0 = opts[0]; cur = { size: o0.size, kant: o0.kant }; }
    paint();

    addBtn.addEventListener('click', function () {
      var chosen = find(cur.size, cur.kant);
      if (!chosen || addBtn.classList.contains('is-busy')) { return; }
      addBtn.classList.add('is-busy');
      var url = ((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: chosen.id, quantity: 1 })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (!res || res.status) { throw new Error((res && res.description) || 'add failed'); }
        closePicker();
        if (cardButton) { cardButton.classList.add('is-done'); cardButton.innerHTML = '<span aria-hidden="true">✓</span>'; }
        cache = { key: '', products: null };
        try { document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: res } })); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(function (err) {
        addBtn.classList.remove('is-busy');
        addBtn.textContent = 'Något gick fel – försök igen';
        if (window.console) { console.warn('peintio-cart add', err); }
      });
    });
    close.addEventListener('click', closePicker);
    backdrop.addEventListener('click', closePicker);
    host.appendChild(backdrop);
    host.appendChild(sheet);
    try { addBtn.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closePicker(); } });
  document.addEventListener('cart-drawer:close', closePicker);

  function initRail() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    var rail = drawer.querySelector('.pc-rail');
    if (!rail || rail.getAttribute('data-ready')) { return; }
    rail.setAttribute('data-ready', '1');
    var productId = rail.getAttribute('data-product-id') || '';
    var exclude = (rail.getAttribute('data-cart-handles') || '').split(',').filter(Boolean);
    var heading = rail.getAttribute('data-heading') || '';
    var wanted = rail.getAttribute('data-variant') || '';
    loadProducts(productId, exclude).then(function (products) {
      if (!document.body.contains(rail)) { return; }
      render(rail, products, heading, wanted);
    }).catch(function (e) { if (window.console) { console.warn('peintio-cart rail', e); } });
  }

  /* ---------- "−" on quantity 1 removes the line, like Rebuy ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var minus = t.closest('cart-drawer.pc .pc-qty .minus');
    if (!minus) { return; }
    var qs = minus.closest('quantity-selector');
    var input = qs && qs.querySelector('.qty');
    if (!input || Number(input.value) > 1) { return; }
    e.preventDefault();
    e.stopPropagation();
    var drawer = document.getElementById(DRAWER_ID);
    if (drawer && typeof drawer.updateQuantity === 'function') {
      drawer.updateQuantity(input.getAttribute('data-index'), '0');
    }
  }, true);

  /* ---------- stale drawer guard (cart changed elsewhere → re-fetch when the drawer opens) ---------- */
  var checking = false;
  function syncIfStale() {
    if (checking) { return; }
    var drawer = document.getElementById(DRAWER_ID);
    var inner = drawer && drawer.querySelector('.pc-body[data-count]');
    if (!inner) { return; }
    checking = true;
    fetchJson('/cart.js').then(function (c) {
      checking = false;
      if (!c || typeof c.item_count !== 'number') { return; }
      if (String(c.item_count) !== inner.getAttribute('data-count')) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }).catch(function () { checking = false; });
  }

  /* ---------- run on open and on every re-render ---------- */
  var queued = false;
  function tick() {
    if (queued) { return; }
    queued = true;
    setTimeout(function () { queued = false; try { initRail(); } catch (e) {} }, 30);
  }
  function watch() {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) { return; }
    try {
      new MutationObserver(tick).observe(drawer, { childList: true, subtree: true });
    } catch (e) {}
    ['cart-drawer:open', 'cart:item-added', 'line-item:change:end', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, tick);
    });
    document.addEventListener('cart-drawer:open', syncIfStale);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { syncIfStale(); } });
    tick();
    if (drawer.querySelector('.pc-rail')) {
      (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () { fetchTopSellers(); });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
